import { Button } from 'primereact/button'
import { Chip } from 'primereact/chip'
import styled from 'styled-components'

export const TableTextButton = styled(Button)`
  width: ${({ width }: { width?: number; height?: number }) => `${width || 100}px`};
  height: ${({ height }: { height?: number }) => `${height || 40}px`};
  justify-content: center;
  color: #363636;
  text-decoration: underline;
  border-radius: 10px;
  color: #363636 !important;

  :focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: none;
    background-color: none;
  }

  :disabled {
    opacity: 0.4;
  }
`

export const TableChip = styled(Chip)`
  background: rgba(173, 187, 255, 0.4);
  padding: 2px 1rem;

  .p-chip-text {
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    color: #363636;
  }
`

export const Line = styled.span`
  font-size: 1.3rem;
  color: #9d9d9d;

  @media (max-width: 1400px) {
    display: none;
  }
`
